<template>
  <edit-protein-details />
</template>

<script>
import EditProteinDetails from '../components/EditProteinDetails.vue';
export default {
  components: { EditProteinDetails },
  metaInfo: {
    title: 'Edit Protein',
    meta: [
      { vmid: 'description', name: 'description', content: 'Edit protein' },
    ]
  },
};
</script>

<style></style>
